import LegalPageLayout from "../components/LegalPageLayout";

const summaryItems = [
    "We collect the information needed to operate Genesis Recovery AI safely and effectively.",
    "Private journals and support interactions are handled with privacy and security in mind.",
    "We do not sell your personal information.",
    "You can contact us anytime about access, corrections, or privacy questions.",
];

const sections = [
    {
        heading: "Information We Collect",
        paragraphs: [
            "We may collect information you provide directly, such as your name, email address, support messages, account details, and any information you choose to share while using Genesis Recovery AI.",
            "We may also collect technical information such as device type, browser details, app usage metrics, IP address, and general analytics data that help us maintain and improve the platform.",
        ],
        bullets: [
            "Account and profile information",
            "Support messages and contact form submissions",
            "Usage, diagnostics, and performance information",
            "Information you voluntarily submit through the platform",
        ],
    },
    {
        heading: "How We Use Information",
        paragraphs: [
            "We use collected information to provide, maintain, and improve Genesis Recovery AI, respond to support requests, troubleshoot issues, protect platform security, and communicate important updates.",
            "We may also use aggregated or de-identified data to better understand how the service is used and to improve product performance and user experience.",
        ],
    },
    {
        heading: "How Your Data Is Protected",
        paragraphs: [
            "We take reasonable administrative, technical, and organizational measures to protect information against unauthorized access, disclosure, or misuse.",
            "No security system is guaranteed to be perfect, but we work to apply privacy-first practices and appropriate safeguards wherever possible.",
        ],
        bullets: [
            "Encryption and secure transmission where appropriate",
            "Access controls for internal systems",
            "Monitoring and maintenance to reduce security risks",
        ],
    },
    {
        heading: "Data Sharing and Disclosure",
        paragraphs: [
            "We do not sell personal information. We may share information with trusted service providers who help us operate the platform, subject to confidentiality and security obligations.",
            "We may also disclose information when required by law, to enforce our terms, or to protect the rights, safety, and security of users, our team, or the public.",
        ],
    },
    {
        heading: "Security Measures",
        paragraphs: [
            "We use safeguards designed to protect platform integrity and user privacy. These safeguards may include secure hosting, limited access, logging, and technical controls appropriate for the nature of the service.",
        ],
    },
    {
        heading: "Your Rights and Choices",
        paragraphs: [
            "Depending on your location, you may have rights regarding access to your information, corrections, deletion requests, or certain limits on processing.",
            "You can contact us to request assistance related to your information, and we will review and respond in accordance with applicable law.",
        ],
        bullets: [
            "Request access to information we maintain",
            "Ask us to correct inaccurate information",
            "Request deletion where legally appropriate",
            "Opt out of certain communications",
        ],
    },
    {
        heading: "Cookies and Tracking",
        paragraphs: [
            "We may use cookies or similar technologies to keep the platform functioning, measure usage, remember preferences, and improve reliability.",
            "You can usually manage cookies through your browser settings, although disabling certain cookies may affect website functionality.",
        ],
    },
    {
        heading: "Children's Privacy",
        paragraphs: [
            "Genesis Recovery AI is not intended for children under the age required by applicable law to use the service without permission. We do not knowingly collect personal information from children in violation of applicable law.",
        ],
    },
    {
        heading: "Changes to This Policy",
        paragraphs: [
            "We may update this Privacy Policy from time to time. If we make material changes, we may update the effective date and provide additional notice where appropriate.",
        ],
    },
    {
        heading: "Contact Us",
        paragraphs: [
            "If you have questions about this Privacy Policy, privacy practices, or your data, please contact Genesis Recovery AI using the contact information below.",
        ],
    },
];

export default function PrivacyPolicyPage() {
    return (
        <LegalPageLayout
            title="Privacy Policy"
            subtitle="How Genesis Recovery AI collects, uses, protects, and handles information shared through the platform."
            summaryTitle="At a glance"
            summaryItems={summaryItems}
            note="Genesis Recovery AI is designed with a privacy-first mindset. This page provides a general explanation of how information may be handled across our website and services."
            sections={sections}
        />
    );
}
